import { useState } from "react";
import { Collapse, Container, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from "reactstrap"

export const NavBarComponent = () => {

    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    return (
        <Navbar expand="lg" fixed="top" className="shadow-sm custom-navbar">
            <Container className="d-flex align-items-center justify-content-between">
                <NavbarBrand href="#home" className="d-flex align-items-center navbar-logo-brand">
                    <img
                        src={`${process.env.PUBLIC_URL}/xplor-logo.png`}
                        alt="Xplor Infrastructures"
                        className="navbar-logo"
                    />
                </NavbarBrand>
                <NavbarToggler onClick={toggle} className="bg-light" />
                <Collapse
                    isOpen={isOpen}
                    navbar
                    className="justify-content-end flex-grow-0"
                    id="navbarNav"
                >
                    <Nav navbar className="align-items-center">
                        <NavItem>
                            <NavLink href="#home">Home</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="#about">About</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="#services">Services</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="#contact">Contact</NavLink>
                        </NavItem>
                    </Nav>
                </Collapse>
            </Container>
        </Navbar>
    )
}